export default __webpack_public_path__ + "static/media/Tree Icon 2.75ab111b.svg";